// extracted by mini-css-extract-plugin
module.exports = {"icons":"socialShareTemplate-m__icons__3JnjJ"};